<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction3" id="benefitAction3" type="radio" />
                        <label for="benefitAction3">{{ formLabels.fields.benefitAction3 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row" v-if="formData.benefit.action === formLabels.fields.benefitAction1">
            <div class="col-12 col-md-6">
                <div :class="['form-field form-field--dropdown', {'form-field--error':$v.formData.benefit.gender.$error}]">
                    <label for="gender1">{{ formLabels.personFields.gender }}</label>
                    <select v-model="formData.benefit.gender">
                        <option :value="null || undefined" disabled>Please select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    <span v-if="formTooltips.sexToolTip" class="form-field__tooltip" v-tooltip="formTooltips.sexToolTip">?</span>
                    <span class="form-field__error" v-if="$v.formData.benefit.gender.$error">This field is required</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="formData.benefit.gender && formData.benefit.action == formLabels.fields.benefitAction1">
            <div class="col-12">
                <h3>Select your membership type</h3>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType1" id="benefitType1" type="radio" />
                        <label for="benefitType1">{{ formLabels.fields.benefitType1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.type" :value="formLabels.fields.benefitType2" id="benefitType2" type="radio" />
                        <label for="benefitType2">{{ formLabels.fields.benefitType2 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.type.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="formData.benefit.action === formLabels.fields.benefitAction2">
            <div class="col-12">
                <h3>{{ formLabels.fields.amendmentDetails }}</h3>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.amendAction" value="Add partner" id="benefitTypeAddFamily" type="radio" />
                        <label for="benefitTypeAddFamily">I want to add my partner</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.amendAction" value="Remove partner" id="benefitTypeRemoveFamily" type="radio" />
                        <label for="benefitTypeRemoveFamily">I want to remove my partner</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="showCost">
            <div class="col-6 col-md-6">
                <div :class="['form-field form-field--currency',{'form-field--error':$v.formData.benefit.cost.$error}]">
                    <label for="cost">{{ formLabels.fields.benefitCost }}</label>
                    <span>£</span><input v-model="formData.benefit.cost" id="cost" step="10000" min="10000" max="500000" @focusout="formatCost" type="number" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.benefit && formTooltips.benefit.fields.benefitCost" v-tooltip="formTooltips.benefit.fields.benefitCost">?</span>
                    <span class="form-field__error" v-if="$v.formData.benefit.cost.$error && !$v.formData.benefit.cost.required">This field is required</span>
                    <span class="form-field__error" v-else-if="$v.formData.benefit.cost.$error">This field is invalid</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="showFamilyFields">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h3>Spouse/Partner details</h3>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].firstName.$error}]">
                            <label for="forename1">{{ formLabels.personFields.firstName }}</label>
                            <input v-model="formData.familyMembers[0].firstName" id="forename1" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.firstName" v-tooltip="formTooltips.personFields.fields.firstName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].firstName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].lastName.$error}]">
                            <label for="lastName1">{{ formLabels.personFields.lastName }}</label>
                            <input v-model="formData.familyMembers[0].lastName" id="lastName1" type="text" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.lastName" v-tooltip="formTooltips.personFields.fields.lastName">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].lastName.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].dob.$error}]">
                            <label for="dob1">{{ formLabels.personFields.dob }}</label>
                            <date-picker v-model="formData.familyMembers[0].dob" id="dob1" format="DD/MM/YYYY" value-type="format"></date-picker>
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.dob" v-tooltip="formTooltips.personFields.fields.dob">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].dob.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div :class="['form-field form-field--dropdown', {'form-field--error':$v.formData.familyMembers.$each[0].gender.$error}]">
                            <label for="gender1">{{ formLabels.personFields.gender }}</label>
                            <select v-model="formData.familyMembers[0].gender">
                                <option :value="null || undefined" disabled>Please select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                            <span v-if="formTooltips.sexToolTip" class="form-field__tooltip" v-tooltip="formTooltips.sexToolTip">?</span>
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.gender" v-tooltip="formTooltips.personFields.fields.gender">?</span>
                            <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].gender.$error">This field is required</span>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6" v-if="showPartnerCost">
                        <div :class="['form-field form-field--currency',{'form-field--error':$v.formData.benefit.partnerCoverLevel.$error}]">
                            <label for="partnerCoverLevel">{{ formLabels.fields.partnerCoverLevel }}</label>
                            <span>£</span><input v-model="formData.benefit.partnerCoverLevel" id="partnerCoverLevel" step="10000" min="10000" max="500000" @focusout="formatCost" type="number" />
                            <span class="form-field__tooltip" v-if="formTooltips && formTooltips.benefit && formTooltips.benefit.fields.partnerCoverLevel" v-tooltip="formTooltips.benefit.fields.partnerCoverLevel">?</span>
                            <span class="form-field__error" v-if="$v.formData.benefit.partnerCoverLevel.$error && !$v.formData.benefit.partnerCoverLevel.required">This field is required</span>
                            <span class="form-field__error" v-else-if="$v.formData.benefit.partnerCoverLevel.$error">This field is invalid</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        },
        formTooltips: {
            type: Object,
        }
    },
    components: { DatePicker },
    inject: ['$v'],
    watch: {
        'formData.benefit.action': {
            handler: function(newVal) {

                // Unset family members
                this.formData.familyMembers = [{}];
                this.formSummary[1].fields = {
                    'Family members': [{}]
                }

                if(this.formData.benefit.type) {
                    this.formData.benefit.type = undefined;
                    this.formSummary[1].fields['Cover type'] = undefined;
                }

                if(this.formData.benefit.amendAction && newVal !== this.formLabels.fields.benefitAction2) {
                    this.formData.benefit.amendAction = undefined;
                }

                if(this.formData.benefit.gender) {
                    this.formData.benefit.gender = undefined;
                }

                if(newVal === this.formLabels.fields.benefitAction3) {
                    this.formData.benefit.cost = undefined;
                }
            }
        },
        'formData.benefit.amendAction': {
            handler: function(newVal) {

                // Unset family members
                this.formData.familyMembers = [{}];
                this.formSummary[1].fields = {
                    'Family members': [{}]
                }

                if(newVal) {
                    this.formData.familyMembers[0].relationship = 'Spouse/Partner';
                    this.formSummary[1].fields = {
                        'Family members': [{ relationship: 'Spouse/Partner' }]
                    }
                }
            }
        },
        'formData.benefit.type': {
            handler: function(newVal) {

                // Reset other form values on add family change
                this.formData.familyMembers = [{}];
                this.formSummary[1].fields = {
                    'Family members': [{}]
                }

                if(newVal === this.formLabels.fields.benefitType2) {
                    this.formData.familyMembers[0].relationship = 'Spouse/Partner';
                    this.formSummary[1].fields = {
                        'Family members': [{ relationship: 'Spouse/Partner' }]
                    }
                }
            
            }
        },
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
        'formData.familyMembers': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        showFamilyFields() {
            return this.formData.benefit.type === this.formLabels.fields.benefitType2 || this.formData.benefit.amendAction;
        },
        benefitFields() {
            return this.formSummary[1].fields;
        },
        showCost() {
            return this.formData.benefit.type || this.formData.benefit.amendAction && this.formData.benefit.amendAction === 'Add partner';
        },
        showPartnerCost() {
            return this.formData.benefit.type;
        }
    },
    methods: {
        formatCost() {
            let cost = this.formData.benefit.cost;

            if(cost > 500000) {
                this.formData.benefit.cost = Number.parseInt(500000).toFixed(0);
            } else if(cost < 10000) {
                this.formData.benefit.cost = Number.parseInt(10000).toFixed(0);
            } else {
                this.formData.benefit.cost = Number.parseInt(Math.round(cost / 10000) * 10000).toFixed(0);
            }
        },
        setConditionals() {
            // We need to store the full object paths for use in the core form
            this.formConditionals.gender = function() { return this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction1 };
            this.formConditionals.benefitType = function() { return this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction1 };
            this.formConditionals.benefitCost = function() { return this.formData.benefit.action
                && (this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction1 || (this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction2 && this.formData.benefit.amendAction === 'Add partner'))}
            this.formConditionals.familyFields = function() { return this.formData.benefit.amendAction || this.formData.benefit.type === this.formLabels.benefit.fields.benefitType2 };
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    action: 'Cover action',
                    amendmentDetails: 'I would like to amend',
                    type: 'Cover type',
                    cost: 'Annual cost',
                    amendAction: 'Amend action',
                    gender: 'Gender'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }

            // Build the family data summary if data is present
            if(Object.keys(this.formData.familyMembers[0])) {
                for(let [mKey,member] of this.formData.familyMembers.entries()) {
                    for(let mfKey of Object.keys(member)) {
                        let label = this.formLabels['personFields'][mfKey];

                        if(label) {
                            this.benefitFields['Family members'][mKey][label] = member[mfKey];
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this.setConditionals();

        this.formSummary.push({
            fields: {
                'Family members': [{}]
            }
        });
    }
}
</script>